export enum ExternalLibIds {
  Opencv = 'opencv-script',
}

export const ExternalLibUrls: Record<ExternalLibIds, string> = {
  [ExternalLibIds.Opencv]: `${process.env.REACT_APP_CDN_URL}/libs/opencv/4.6.0/opencv_4.6-1.0.3.js`,
};
